import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'addSpaceBeforeUppercase',
  standalone: true,
})
export class AddSpaceBeforeUppercasePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value; // Return value as it is if it's falsy

    // Convert the first letter to uppercase
    let transformedValue = value.charAt(0).toUpperCase() + value.slice(1);

    // Use regular expression to add a space before subsequent uppercase letters
    transformedValue = transformedValue.replace(/([A-Z])/g, ' $1');

    return transformedValue;
  }
}
